export enum StatisticsElementType {
  ARM = 'arm',
  ROUTER = 'router',
  NODE = 'node',
  PEER_CONNECTION = 'pcon',
  CONNECTION = 'connection',
  ROUTING_GROUP = 'routingGroup',
  ROUTING_RULE = 'routingRule',
  CALLS_QUOTA = 'callsQuota',
  RESOURCE_GROUP = 'resourceGroup',
  CUSTOMER = 'customer',
  VOIP_PEER = 'voipPeer'
}
